const api_url = "https://apis.ittcouncil.com/";

const api_url_2 = "https://franchiseapis.ittcouncil.com/";

export { api_url, api_url_2 }